<template>
    <div :id="mapId + 'map-wrapper'" class="h-100">
        <div :id="mapId" class="h-100"></div>
        <div ref="popup" class="ol-popup origin">
            <div :id="mapId + 'popup-light'" class="ol-popup-light"></div>
            <!-- <a href="#" :id="mapId + 'popup-closer'" class="ol-popup-closer"></a> -->
            <div :id="mapId + 'popup-content'"></div>
        </div>
        <template v-if="isShowLayer">
            <div class="btn-layer-wrapper">
                <div class="content" @click="aroundShow = !aroundShow">
                    <img src="@/assets/map_ic_around.png" alt="柳川周邊遊" />
                    <div class="title">柳川周邊遊</div>
                </div>
                <div class="layer-wrapper" :class="{ active: aroundShow }">
                    <ul class="m-0">
                        <li
                            class="layer-item"
                            v-for="lyrName in aroundGroup"
                            :key="lyrName"
                        >
                            <label class="container-checkbox"
                                ><span v-text="customLayers[lyrName].name"
                                    >景點</span
                                >
                                <input
                                    type="checkbox"
                                    v-model="customLayers[lyrName].isVisible"
                                    @change="triggerLayerHandler(lyrName)"/>
                                <span class="checkmark"></span
                            ></label>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btn-layer-wrapper trail">
                <div class="content" @click="trailShow = !trailShow">
                    <img src="@/assets/map_ic_trail.png" alt="柳川步道探訪" />
                    <div class="title">柳川步道探訪</div>
                </div>
                <div class="layer-wrapper" :class="{ active: trailShow }">
                    <ul class="m-0">
                        <li
                            class="layer-item"
                            v-for="lyrName in trailGroup"
                            :key="lyrName"
                        >
                            <label class="container-checkbox"
                                ><span v-text="customLayers[lyrName].name"
                                    >景點</span
                                >
                                <input
                                    type="checkbox"
                                    v-model="customLayers[lyrName].isVisible"
                                    @change="triggerLayerHandler(lyrName)"/>
                                <span class="checkmark"></span
                            ></label>
                        </li>
                    </ul>
                </div>
            </div>
        </template>
        <a
            class="btn-gps-wrapper"
            v-if="isShowGps"
            @click="setMapCenter(...currentPosition)"
        >
            <div class="btn-gps"></div>
        </a>
    </div>
</template>

<script>
/* eslint-disable global-require */
import { Feature, Overlay } from 'ol';
import Point from 'ol/geom/Point';
import { mapActions, mapState } from 'vuex';
import { transform } from 'ol/proj';
import { Icon, Style } from 'ol/style';
import VectorSource from 'ol/source/Vector';
import { Vector as VectorLayer } from 'ol/layer';
import GMap from '@/js/map/main';
import proj4 from '@/js/map/proj4reg';

export default {
    name: 'Map',
    props: {
        // 地圖Id
        mapId: {
            type: String,
            default: 'gmap',
        },
        // 分析Id
        recordId: {
            type: String,
            default: '',
        },
        // 地圖點位原始資料
        oriMapPoints: {
            type: Object,
            default() {
                return {
                    // marker點位
                    iconLayer: [],
                    // 起訖分析
                    flightLayer: {},
                    // 網格
                    gridLayer: [],
                };
            },
        },
        // 是否觸發地圖更新
        triggerLayer: {
            type: Boolean,
            default: false,
        },
        // 地圖中心
        center: {
            type: Array,
        },
        // 地圖fit參數
        fitOption: {
            type: Object,
            default() {
                return {
                    padding: [50, 50, 50, 50],
                };
            },
        },
        // 是否為雙地圖
        isDoubleMap: {
            type: Boolean,
            default: false,
        },
        // 是否為全螢幕地圖
        isFullScreen: {
            type: Boolean,
            default: true,
        },
        // 判斷是否為匯出頁面，如果是nlsc就改呼叫mapProxy
        isExport: {
            type: Boolean,
            default: false,
        },
        // 是否顯示圖層選項
        isShowLayer: {
            type: Boolean,
            default: true,
        },
        // 是否顯示Gps
        isShowGps: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            // urls: apiUrl,
            // 地圖實例物件
            gmap: null,
            // 客製化圖層
            customLayers: {
                attractionListLayer: {
                    name: '景點',
                    color: '',
                    url: null,
                    lyrName: 'attractionListLayer',
                    lyrKind: 'icon',
                    isShowName: true,
                    isVisible: false,
                    zIndex: 2,
                },
                foodListLayer: {
                    name: '美食',
                    color: '',
                    url: null,
                    lyrName: 'foodListLayer',
                    lyrKind: 'icon',
                    isShowName: true,
                    isVisible: false,
                    zIndex: 2,
                },
                commentaryListLayer: {
                    name: '解說牌',
                    color: '',
                    url: null,
                    lyrName: 'commentaryListLayer',
                    lyrKind: 'icon',
                    isShowName: true,
                    isVisible: false,
                    zIndex: 2,
                },
                qrcodesListLayer: {
                    name: 'QRCode',
                    color: '',
                    url: null,
                    lyrName: 'qrcodesListLayer',
                    lyrKind: 'icon',
                    isShowName: true,
                    isVisible: false,
                    zIndex: 2,
                },
            },
            // 地圖點位資料
            mapPoints: {
                // marker點位
                iconLayer: [],
                // // 起訖分析
                // flightLayer: {},
                // // 網格
                // gridLayer: [],
            },
            aroundGroup: ['attractionListLayer', 'foodListLayer'],
            trailGroup: ['commentaryListLayer', 'qrcodesListLayer'],
            trailShow: false,
            aroundShow: false,
        };
    },
    mounted() {
        // 預設地圖中心點: 台中市
        const center = this.convertCoord([
            120.6629271080446,
            24.200110955671352,
        ]);

        // 地圖參數
        const mapParam = {
            mapId: this.mapId,
            options: {
                projection: 'EPSG:3826',
                center: {
                    lat: center[1],
                    lng: center[0],
                },
                zoom: 12,
                maxZoom: 20,
                isFullScreen: this.isFullScreen,
                isDoubleMap: this.isDoubleMap,
                disableDefaultUI: true,
            },
            baseLayers: [
                {
                    name: '通用版電子地圖',
                    type: 'nlsc',
                    visible: true,
                    isExport: this.isExport,
                },
            ],
        };

        // new 地圖實例
        this.gmap = new GMap(mapParam);
        // debug使用
        window[this.mapId] = this.gmap;
        // 現在位置
        this.addPositionLayer();

        this.setMarkerClickEvent();
    },
    computed: {
        ...mapState('userData', ['currentPosition', 'spotPosition']),
        aroundClassActive() {
            return this.aroundGroup.some(
                (lyrName) => this.customLayers[lyrName]
                    && this.customLayers[lyrName].isVisible,
            );
        },
        trailClassActive() {
            return this.trailGroup.some(
                (lyrName) => this.customLayers[lyrName]
                    && this.customLayers[lyrName].isVisible,
            );
        },
    },
    methods: {
        ...mapActions('userData', [
            'setCurrentPosition',
            'setPositionErrorCode',
        ]),
        getDetail(d) {
            this.$emit('getdetail', d);
        },
        createOverlay(f, isVisible) {
            const vm = this.gmap.olmap;

            /**
             * Elements that make up the popup.
             */
            const container = this.$refs.popup;
            const content = this.$refs.popup.querySelector('.ol-popup-content');
            const light = document.querySelector('.ol-popup-light');

            const cContainer = container.cloneNode(true);
            const cContent = content.cloneNode(true);
            const cLight = light.cloneNode(true);
            cContainer.className = 'ol-popup ol-popup-clone';
            cContainer.style.display = isVisible ? 'block' : 'none';
            cContainer.innerHTML = '';
            cContainer.style.cursor = 'pointer';
            document
                .getElementById(`${this.mapId}map-wrapper`)
                .appendChild(cContainer);
            cContainer.appendChild(cContent);
            cContainer.appendChild(cLight);

            /**
             * Create an overlay to anchor the popup to the map.
             */
            const overlay = new Overlay({
                element: cContainer,
                autoPan: true,
                autoPanAnimation: {
                    duration: 250,
                },
            });

            vm.addOverlay(overlay);

            if (!f) {
                return;
            }
            const coordinates = f.getGeometry().getCoordinates();

            const lv = f.get('lightRt');

            switch (lv) {
                case 0:
                    cLight.style.backgroundColor = '#96cf56';
                    break;
                case 1:
                    cLight.style.backgroundColor = '#edd21f';
                    break;
                case 2:
                    cLight.style.backgroundColor = '#ff5454';
                    break;
                default:
                    cLight.style.backgroundColor = '#aeaeae';
                    break;
            }
            // cLight.style.backgroundColor = !lv ? '#96cf56' : (lv === 2 ? '#ff5454' : '#edd21f');
            cContent.innerHTML = `<div>
            <img src="${f.get('photo')}" alt="${f.get(
    'name',
)}" style="width: 100%; margin-bottom: .5em;" />
            <div style="font-size: .9em; line-height: 1.2">${f.get(
        'name',
    )}</div>
            </div>`;

            cContent.onclick = () => {
                this.mapPoints.overlayLayer.some((item) => {
                    if (item.id === f.get('id')) {
                        this.getDetail({
                            spotId: item.id,
                            name: item.name,
                            nameEn: item.nameEn,
                            photoSm: item.photo,
                            lat: item.lat,
                            lon: item.lon,
                            lightRt: item.lightRt,
                            wkt: item.wkt,
                        });
                        return true;
                    }
                    return false;
                });
            };

            overlay.setPosition(coordinates);
            // vm.on('click', (evt) => {
            //     const feature = vm.forEachFeatureAtPixel(evt.pixel, f => f);
            //     if (!feature) {
            //         return;
            //     }
            //     const coordinates = feature.getGeometry().getCoordinates();

            //     const lv = feature.get('lightRt');
            //     cLight.style.backgroundColor = !lv ? '#96cf56' : (lv === 2 ? '#ff5454' : '#edd21f');
            //     cContent.innerHTML = `<div>
            //     <img src="${feature.get('photo')}" alt="${feature.get('name')}" style="width: 100%; margin-bottom: .5em;" />
            //     <div style="font-size: .9em; line-height: 1.2">${feature.get('name')}</div>
            //     </div>`;
            //     overlay.setPosition(coordinates);
            // });
        },
        setMarkerClickEvent() {
            const vm = this.gmap.olmap;

            vm.on('click', (evt) => {
                // eslint-disable-next-line
                // debugger;
                const feature = vm.forEachFeatureAtPixel(evt.pixel, (f) => f);
                if (!feature || !feature.get('callback')) {
                    return;
                }

                feature.get('callback')();
            });
        },
        /**
         * xy轉換坐標系統
         * @param {Array} coord xy
         * @param {String} epsgFrom 來源系統
         * @param {String} epsgTo 目標系統
         */
        convertCoord(coord, epsgFrom, epsgTo) {
            const rEpsgTo = epsgTo || 'EPSG:3826';
            const rEpsgFrom = epsgFrom || 'EPSG:4326';
            return proj4(rEpsgFrom, rEpsgTo, coord);
        },
        /**
         * 傳入資料取得icon型的Feature
         * @param {array} data 資料
         * @returns Features
         */
        getIconFeature(data) {
            const fs = data.map((f, idx) => {
                const xy = [f.lon, f.lat];
                const pos = this.convertCoord(xy);
                return new Feature({
                    id: f.id ? f.id : idx + 1,
                    geometry: new Point(pos),
                    name: f.name,
                    photo: f.photo,
                    style: null,
                    iconUrl: f.iconUrl,
                    lightRt: f.lightRt,
                    callback: f.callback,
                });
            });
            return fs;
        },
        /**
         * 取得圖層資料，判斷是否新增圖層或開關圖層
         * @param {String} lyrName 圖層名稱(Id)
         */
        layerHandler(lyrName) {
            const vm = this;
            let lyr = null;
            const { methods } = this.gmap;

            // 如果gmap已經存在圖層，則控制圖層顯示與否
            if (this.gmap.customLayers[lyrName]) {
                vm.gmap.methods.toggleLayer(vm.customLayers[lyrName]);
                // overlay要可以跟著開關
                if (vm.customLayers[lyrName].lyrKind === 'overlay') {
                    document
                        .querySelectorAll(`#${this.mapId}popup`)
                        .forEach((node) => {
                            node.style.display = this.gmap.customLayers[
                                lyrName
                            ].getVisible()
                                ? 'block'
                                : 'none';
                        });
                }
                return;
            }
            if (!vm.customLayers[lyrName].isVisible) {
                return;
            }
            /**
             * 根據圖層類型新增圖層
             */
            switch (vm.customLayers[lyrName].lyrKind) {
                case 'icon':
                    lyr = methods.getIconLayer(
                        vm.getIconFeature(vm.mapPoints[lyrName]),
                        vm.customLayers[lyrName],
                    );
                    break;
                case 'overlay':
                    lyr = methods.getOverlayLayer(
                        vm.getIconFeature(vm.mapPoints[lyrName]),
                        vm.customLayers[lyrName],
                        vm.createOverlay,
                    );
                    break;
                case 'circle':
                    lyr = methods.getCircleLayer(
                        methods.getCircleFeature(vm.mapPoints[lyrName]),
                        vm.customLayers[lyrName],
                    );
                    break;
                case 'cluster':
                    lyr = methods.getClusterLayer(
                        methods.getClusterFeature(vm.mapPoints[lyrName]),
                        vm.customLayers[lyrName],
                    );
                    break;
                case 'bubble':
                    lyr = vm.gmap.methods.getBubbleLayer(
                        vm.getBubbleFeature(vm.mapPoints[lyrName]),
                        vm.mapPoints.bubbleLayer.center,
                        vm.customLayers[lyrName],
                    );
                    break;
                // 網格地圖
                case 'grid':
                    lyr = vm.gmap.methods.getGridLayer(
                        vm.getHeatFeature(
                            vm.mapPoints[lyrName],
                            vm.customLayers[lyrName],
                        ),
                        vm.customLayers[lyrName],
                    );
                    break;
                // 網格地圖swipe
                case 'grid2':
                    lyr = vm.gmap.methods.getGridLayer(
                        vm.getHeatFeature(
                            vm.mapPoints[lyrName],
                            vm.customLayers[lyrName],
                        ),
                        vm.customLayers[lyrName],
                        'swipeInput',
                    );
                    break;
                // 量測
                case 'measure':
                    lyr = vm.gmap.methods.getMeasureLayer(
                        vm.customLayers[lyrName],
                    );
                    break;
                // 標繪
                case 'draw':
                    lyr = vm.gmap.methods.getDrawLayer(
                        vm.customLayers[lyrName],
                    );
                    break;
                case 'wkt':
                    lyr = vm.gmap.methods.getWKTLayer(
                        vm.mapPoints[lyrName][0].geom,
                        vm.customLayers[lyrName],
                    );
                    break;
                default:
                    break;
            }

            if (lyr) {
                this.gmap.methods.addLayer(
                    vm.customLayers[lyrName].lyrName,
                    lyr,
                );
            }
        },
        /**
         * 設定中心點 4326 WSG84
         * @param {Float} x X
         * @param {Float} y Y
         * @param {Object} options 選項
         */
        setMapCenter(x, y, options = { duration: 1500 }) {
            function setMapCenter(lon, lat) {
                const coords = transform(
                    [lon, lat],
                    'EPSG:4326',
                    this.gmap._mapConfig.options.projection,
                );

                this.gmap.olmap.getView().animate({
                    zoom: 19,
                    center: coords,
                    duration: options.duration,
                });
                this.gmap.positionLayer
                    .getSource()
                    .getFeatures()[0]
                    .getGeometry()
                    .setCoordinates(coords);
            }
            if (x === 0 || y === 0) {
                // 沒有定位須詢問
                if (!navigator.geolocation) {
                    console.log('瀏覽器不支援GPS定位');
                    return;
                }
                navigator.geolocation.getCurrentPosition(
                    // success
                    (pos) => {
                        this.setCurrentPosition([
                            pos.coords.longitude,
                            pos.coords.latitude,
                        ]);
                        setMapCenter.call(
                            this,
                            pos.coords.longitude,
                            pos.coords.latitude,
                        );
                    },
                    // error
                    (error) => {
                        console.log(error.message);
                        this.setCurrentPosition([0, 0]);
                        this.setPositionErrorCode(error.code);
                    },
                );
            } else {
                setMapCenter.call(this, x, y);
            }
        },
        triggerLayerHandler(lyrName) {
            this.mapPoints[lyrName] = this.oriMapPoints[lyrName];
            if (this.mapPoints[lyrName] && this.mapPoints[lyrName].length > 0) {
                this.removeLayer(lyrName);
                this.layerHandler(lyrName);
            }
        },
        removeLayer(lyrName) {
            if (this.gmap.customLayers[lyrName]) {
                if (this.customLayers[lyrName].lyrKind === 'overlay') {
                    document
                        .querySelectorAll('.ol-popup-clone')
                        .forEach((node) => {
                            node.remove();
                        });
                }
                this.gmap.olmap.removeLayer(this.gmap.customLayers[lyrName]);
                delete this.gmap.customLayers[lyrName];
            }
        },
        setLayerVisible(lyrName, isVisible) {
            this.customLayers[lyrName].isVisible = isVisible;
        },
        toggleLayerVisible(lyrName, isVisible) {
            this.setLayerVisible(
                lyrName,
                isVisible === undefined
                    ? !this.customLayers[lyrName].isVisible
                    : isVisible,
            );

            this.triggerLayerHandler(lyrName);
        },
        addPositionLayer() {
            const iconFeature = new Feature({
                geometry: new Point([0, 0]),
                name: '現在位置',
            });

            const iconStyle = new Style({
                image: new Icon({
                    anchor: [0.5, 46],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'pixels',
                    opacity: 0.75,
                    src: require('@/assets/needle.gif'),
                }),
            });
            iconFeature.setStyle(iconStyle);
            const vectorSource = new VectorSource({
                features: [iconFeature],
            });

            const vectorLayer = new VectorLayer({
                source: vectorSource,
                visible: this.isShowPosition,
            });

            this.gmap.olmap.addLayer(vectorLayer);
            this.gmap.positionLayer = vectorLayer;
        },
    },
    watch: {
        /**
         * 觸發layerHandler
         */
        triggerLayer() {
            this.mapPoints = this.oriMapPoints;
            Object.keys(this.oriMapPoints).forEach((key) => {
                this.triggerLayerHandler(key);
            });
        },
        /**
         * zoom in selected spot
         */
        spotPosition() {
            this.setMapCenter(...this.spotPosition);
        },
    },
};
</script>

<style lang="sass" scoped>
.ol-popup
    position: absolute
    background-color: white
    box-shadow: 0 1px 4px rgba(0,0,0,0.2)
    display: none
    padding: 15px
    border-radius: 10px
    border: 1px solid #cccccc
    bottom: 12px
    left: -50px
    min-width: 9em

.ol-popup:after, .ol-popup:before
    top: 100%
    border: solid transparent
    content: " "
    height: 0
    width: 0
    position: absolute
    pointer-events: none

.ol-popup:after
    border-top-color: white
    border-width: 10px
    left: 48px
    margin-left: -10px

.ol-popup:before
    border-top-color: #cccccc
    border-width: 11px
    left: 48px
    margin-left: -11px

.ol-popup-light
    background-color: #edd21f
    border: 4px solid #fff
    border-radius: 50%
    position: absolute
    top: -8px
    right: -8px
    width: 1.6em
    height: 1.6em
    &.green
        background-color: #96cf56
    &.red
        background-color: #ff5454
    &.gray
        background-color: #aeaeae

// .ol-popup-closer
//     text-decoration: none
//     position: absolute
//     top: 2px
//     right: 8px

// .ol-popup-closer:after
//     content: "✖"

.geo-fullScreen
    // height: 100vh
    &.geo-doublemap
        width: 100%
.origin
    display: none !important
</style>
